import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { siteData } from "@/store/siteData";
import { getStoryBySlug, storyParagraphs, storySlug } from "@/utils/blog";

export default function Makale() {
  const { slug } = useParams();
  const story = slug ? getStoryBySlug(slug) : undefined;

  if (!story) {
    return (
      <main className="bg-white min-h-screen">
        <Navbar />
        <section className="container-x pt-40 pb-32 text-center">
          <i className="ri-file-search-line text-5xl text-muted"></i>
          <p className="mt-4 text-muted">Aradığınız makale bulunamadı.</p>
          <Link to="/makaleler" className="mt-5 inline-flex items-center gap-1.5 text-brand font-semibold"><i className="ri-arrow-left-line"></i> Tüm Makaleler</Link>
        </section>
        <Footer />
      </main>
    );
  }

  const paras = storyParagraphs(story);
  const others = siteData.getStories().items.filter((s) => s.id !== story.id).slice(0, 3);

  return (
    <main className="bg-white">
      <Navbar />

      <article className="container-x pt-32 pb-16">
        <div className="mx-auto max-w-3xl">
          <Link to="/makaleler" className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand mb-6"><i className="ri-arrow-left-line"></i> Tüm Makaleler</Link>
          <p className="flex items-center gap-1.5 text-xs font-medium text-muted mb-3"><i className="ri-calendar-line"></i>{story.date}</p>
          <h1 className="font-display text-3xl font-bold leading-tight text-ink sm:text-4xl">{story.title}</h1>

          <div className="relative mt-8 aspect-[16/9] overflow-hidden rounded-2xl border border-line">
            <img src={story.imageUrl} alt={story.title} className="absolute inset-0 h-full w-full object-cover" />
          </div>

          <div className="mt-8 space-y-5">
            {paras.map((p, i) => (
              <p key={i} className="text-[17px] leading-relaxed text-ink/80">{p}</p>
            ))}
          </div>

          <div className="mt-12 flex flex-col items-center justify-between gap-4 rounded-2xl border border-line bg-surface p-6 sm:flex-row">
            <div>
              <p className="font-display text-lg font-bold text-ink">Bu çözüm hakkında bilgi almak ister misiniz?</p>
              <p className="text-sm text-muted">Uzman ekibimiz size en uygun çözümü sunsun.</p>
            </div>
            <Link to="/#iletisim" className="shrink-0 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-dark">İletişime Geç</Link>
          </div>
        </div>
      </article>

      {others.length > 0 && (
        <section className="container-x pb-20">
          <div className="mx-auto max-w-5xl">
            <h2 className="mb-6 font-display text-2xl font-bold text-ink">Diğer Makaleler</h2>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
              {others.map((a) => (
                <Link key={a.id} to={`/makale/${storySlug(a)}`} className="group flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-soft transition-all hover:-translate-y-1 hover:border-brand/30 hover:shadow-card">
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img src={a.imageUrl} alt={a.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  </div>
                  <div className="flex flex-1 flex-col gap-2 p-5">
                    <p className="text-xs text-muted">{a.date}</p>
                    <h3 className="font-display text-base font-bold leading-tight text-ink transition-colors group-hover:text-brand">{a.title}</h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <Footer />
    </main>
  );
}
